import React, { useEffect } from 'react'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import Brands from './Brands/Brands'
import ForBrands from './ForBrands/ForBrands'
import KiranaCredit from './KiranaCredit/KiranaCredit'
import LynkVsOthers from './LynkVsOthers/LynkVsOthers'
import SupplyChain from './SupplyChain/SupplyChain'
import './HomePage.scss'
import { useParams } from 'react-router-dom'
import OurFootprint from './OurFootprint/OurFootprint'
import addAnalytics from '../../utils/analytics'
// import Testimonials from './Testimonials/Testimonials'

const HomePage = () => {
    const { sectionId } = useParams();

    useEffect(() => {     
        if (sectionId) {
            addAnalytics("Homepage", `User Redirects to ${sectionId}`);

            const scrollToSection = () => {
                const targetSection = document.getElementById(sectionId);
                if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            };

            if (document.readyState === 'complete') {
                scrollToSection();
            } else {
                window.addEventListener('load', scrollToSection);
                return () => window.removeEventListener('load', scrollToSection);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='homepage'>
            <Header />
            <ForBrands />
            <SupplyChain />
            <LynkVsOthers />
            <KiranaCredit />
            <Brands />
            {/* <Testimonials /> */}
            <OurFootprint />
            <Footer />
        </div>
    )
}

export default HomePage